import React, { ReactNode, createContext, useContext } from "react";

import { createHistoryState } from "./states/history";
import { createOpenState } from "./states/open";
import { createLoadingState } from "./states/loading";
import { createInputState } from "./states/input";
import { createMaximizeState } from "./states/maximize";

const ChatContext = createContext<any>(null);

export function ChatContextProvider({children}: {children: ReactNode}): React.ReactElement {
    const history = createHistoryState();
    const open = createOpenState();
    const loading = createLoadingState();
    const input = createInputState();
    const maximize = createMaximizeState();

    return (
        <ChatContext.Provider
            value={{
                chat: {
                    loadingState: loading.state,
                    isLoading: loading.isLoading,
                    load: loading.load,
                    loaded: loading.loaded,

                    maximizedState: maximize.state,
                    isMaximized: maximize.isMaximized,
                    maximize: maximize.maximizeChat,
                    minimize: maximize.minimizeChat,

                    openState: open.state,
                    isOpen: open.isOpen,
                    close: open.closeChat,
                    open: open.openChat,
                },
                history,
                input,
            }}
        >
            {children}
        </ChatContext.Provider>
    );
}

export function useChatContext(): any {
    const context = useContext(ChatContext);

    if (!context) {
        throw new Error(
            "useChat must be used inside ChatProvider"
        );
    }

    return context;
}
